import * as React from 'react';
import {Mutation} from 'react-apollo';

import {Button} from 'shells/button/button';
import {ConfirmationDialog} from 'shells/confirmation-dialog/confirmation-dialog';

import type {
    PauseAutomatedEmails as pauseAutomatedEmailsMutation,
    ResumeAutomatedEmails as resumeAutomatedEmailsMutation,
} from 'nutshell-graphql-types';

import PAUSE_AUTOMATED_EAMILS from './graphql/mutations/pause-automated-emails.graphql';
import RESUME_AUTOMATED_EMAILS from './graphql/mutations/resume-automated-emails.graphql';

class PauseAutomatedEmails extends Mutation<pauseAutomatedEmailsMutation, Record<any, any>> {}
class ResumeAutomatedEmails extends Mutation<resumeAutomatedEmailsMutation, Record<any, any>> {}

type Props = {
    isSendingPaused: boolean;
};

export function ToggleAutomatedEmailSendingButton(props: Props) {
    const [isConfirmationOpen, setIsConfirmationOpen] = React.useState<boolean>(false);

    return (
        <PauseAutomatedEmails mutation={PAUSE_AUTOMATED_EAMILS} refetchQueries={['GetEmailStats']}>
            {(pauseAutomatedEmails, {loading: pauseMutationInFlight}) => (
                <ResumeAutomatedEmails
                    mutation={RESUME_AUTOMATED_EMAILS}
                    refetchQueries={['GetEmailStats']}
                >
                    {(resumeAutomatedEmails, {loading: resumeMutationInFlight}) => (
                        <React.Fragment>
                            <Button onClick={() => setIsConfirmationOpen(true)} size='big'>
                                {props.isSendingPaused
                                    ? 'Resume sending automated emails'
                                    : 'Pause all outgoing emails'}
                            </Button>
                            {isConfirmationOpen && props.isSendingPaused ? (
                                <ConfirmationDialog
                                    title='Ready to turn automated emails back on?'
                                    message='Any emails that would have sent while sending was paused will be rescheduled to send in 15 minutes.'
                                    onConfirm={() => {
                                        resumeAutomatedEmails().then(() => {
                                            setIsConfirmationOpen(false);
                                        });
                                    }}
                                    onCancel={() => setIsConfirmationOpen(false)}
                                    confirmText={
                                        resumeMutationInFlight
                                            ? 'Resuming automated emails…'
                                            : 'Yes, resume sending automations'
                                    }
                                    cancelText='Not right now'
                                />
                            ) : undefined}
                            {isConfirmationOpen && !props.isSendingPaused ? (
                                <ConfirmationDialog
                                    title='Are you sure you want to pause the sending of your automated emails?'
                                    message='When sending is paused, Nutshell will prevent any automated emails from being sent. You can turn this off at any time.'
                                    onConfirm={() => {
                                        pauseAutomatedEmails().then(() => {
                                            setIsConfirmationOpen(false);
                                        });
                                    }}
                                    onCancel={() => setIsConfirmationOpen(false)}
                                    confirmText={
                                        pauseMutationInFlight
                                            ? 'Pausing automated emails…'
                                            : 'Yes, pause email sending'
                                    }
                                    cancelText='Not right now'
                                />
                            ) : undefined}
                        </React.Fragment>
                    )}
                </ResumeAutomatedEmails>
            )}
        </PauseAutomatedEmails>
    );
}
